import React from "react";
import { Breadcrumb } from "antd";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

const MainBreadcrumb = () => {
  const location = useLocation();
  const [t] = useTranslation();

  let segments = location.pathname.split("/").filter(s=>s);

  type pathType = {
    to: string;
    label: string;
    key: number;
  };

  let paths = Array<pathType>();

  paths.push({
    to: "/",
    label: "dashboard",
    key: 1
  });

  let pathBuilder = "";

  segments.forEach((s, i) => {
    pathBuilder += "/" + s;

    paths.push({
      to: pathBuilder,
      label: s,
      key: i + 2
    });
  });

  return (
    <Breadcrumb className="px-4 py-2 bg-gray-100 border-b border-gray-200" style={{borderBottomStyle: 'solid'}}>
      {paths.map((path, i) => (
        <Breadcrumb.Item key={path.key}>
          {i === paths.length - 1 ? 
            <span>{t(path.label)}</span>
           : 
            <Link to={ path.to } state={ location.state }>{t(path.label)}</Link>
          }
        </Breadcrumb.Item>
      ))}
    </Breadcrumb>
  );
};

export default MainBreadcrumb;
